var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfinity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "ip",
    viewBox: "0 0 256 128",
    width: "256px",
    height: "128px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00aeef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2",
    x1: 1,
    y1: 0,
    x2: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00aeef"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .ip {\n      width: 25px;\n      height: 16px;\n    }\n    .ip__track {\n      stroke: #2ac2f580;\n    }\n    .ip__worm1,\n    .ip__worm2 {\n      animation: worm1 3s linear infinite;\n    }\n    .ip__worm2 {\n      animation-name: worm2;\n    }\n\n    @keyframes worm1 {\n      from {\n        stroke-dashoffset: 0;\n      }\n      50% {\n        animation-timing-function: steps(1);\n        stroke-dashoffset: -358;\n      }\n      50.01% {\n        animation-timing-function: linear;\n        stroke-dashoffset: 358;\n      }\n      to {\n        stroke-dashoffset: 0;\n      }\n    }\n    @keyframes worm2 {\n      from {\n        stroke-dashoffset: 358;\n      }\n      50% {\n        stroke-dashoffset: 0;\n      }\n      to {\n        stroke-dashoffset: -358;\n      }\n    }\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 16
  }, /*#__PURE__*/React.createElement("g", {
    className: "ip__track",
    stroke: "#ddd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,64s0-56,60-56,60,112,120,112,60-56,60-56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,64s0-56-60-56-60,112-120,112S8,64,8,64"
  })), /*#__PURE__*/React.createElement("g", {
    strokeDasharray: "180 656"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ip__worm1",
    stroke: "url(#grad1)",
    strokeDashoffset: 0,
    d: "M8,64s0-56,60-56,60,112,120,112,60-56,60-56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ip__worm2",
    stroke: "url(#grad2)",
    strokeDashoffset: 358,
    d: "M248,64s0-56-60-56-60,112-120,112S8,64,8,64"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinity);
export default __webpack_public_path__ + "static/media/infinity.99c3ad1c8198a78ac16f65dfce10e14a.svg";
export { ForwardRef as ReactComponent };